import React from 'react';
export function FinalThoughts() {
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="thoughts-heading" data-id="element-107" data-mp="2oo4wbem097ls">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-108" data-mp="2exwndmb32sb7">
        <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-109" data-mp="2sptcdhhggm3d">
          Final thoughts
        </p>
        <h2 id="thoughts-heading" className="mt-4 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-espresso sm:text-5xl" data-id="element-110" data-mp="2op9icms6hylg">
          Stop improvising. Start building.
        </h2>
        <p className="mx-auto mt-6 max-w-prose font-sans text-lg leading-relaxed text-cocoa" data-id="element-111" data-mp="1w1nd7a3aylwh">
          You already have the hands and the eye. What you deserve is a system that turns
          that talent into an income you control.
        </p>
        <p className="mx-auto mt-4 max-w-prose font-sans text-lg leading-relaxed text-cocoa" data-id="element-112" data-mp="3ldfqhjob794h">
          Join 5,000+ stylists who now book, price and deliver like a salon — from home.
        </p>
        <p className="mt-8 font-display text-2xl font-semibold text-espresso" data-id="element-113" data-mp="1qv631y313svm">
          Stop the guessing. Start the system.
        </p>
      </div>
    </section>;
}